import { memo, useState } from 'react';

const TWEMOJI_CDN = 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg';

function emojiToCodepoint(emoji: string): string {
  const codePoints: string[] = [];
  let i = 0;
  while (i < emoji.length) {
    const cp = emoji.codePointAt(i);
    if (cp === undefined) break;
    if (cp !== 0xfe0f) {
      codePoints.push(cp.toString(16));
    }
    i += cp > 0xffff ? 2 : 1;
  }
  return codePoints.join('-');
}

interface TwemojiProps {
  emoji: string;
  size?: number;
  className?: string;
}

export const Twemoji = memo(function Twemoji({ emoji, size = 40, className = '' }: TwemojiProps) {
  const [failed, setFailed] = useState(false);
  const codepoint = emojiToCodepoint(emoji);

  if (failed) {
    return (
      <span
        className={`inline-flex items-center justify-center select-none ${className}`}
        style={{ width: size, height: size, fontSize: size * 0.75, lineHeight: 1 }}
        aria-label={emoji}
      >
        {emoji}
      </span>
    );
  }

  return (
    <img
      src={`${TWEMOJI_CDN}/${codepoint}.svg`}
      alt={emoji}
      width={size}
      height={size}
      draggable={false}
      className={`inline-block select-none ${className}`}
      style={{ width: size, height: size }}
      onError={() => setFailed(true)}
    />
  );
});
